(ns frontend.view.grid.real-estates-grid.columns
  (:require [frontend.state.current-session :as session]))

;;default set of selected columns
(def ordered-default-columns
  [:asset/name
   :asset/description
   :asset/city
   :real-estate/tag-tags
   :real-estate/current-yield
   :real-estate/occupancy-rate])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:asset/name})
